import { InAppMessageView } from "./view/InAppMessageView"
import { InAppMessageViewFactory } from "./view/InAppMessageViewFactory"
import { InAppMessageEventHandler } from "./event/InAppMessageEventHandler"
import { InAppMessageInteractionHandlerFactory } from "./event/InAppMessageInteractionHandler"
import { HackleInAppMessageListener } from "../../../public/model"
import { InAppMessagePresenter } from "../present/presentation/InAppMessagePresenter"
import { InAppMessagePresentationContext } from "../present/presentation/InAppMessagePresentationContext"

export class InAppMessageUi implements InAppMessagePresenter {
  public currentMessageView: InAppMessageView | null = null
  private opening: boolean = false

  constructor(
    private readonly messageViewFactory: InAppMessageViewFactory,
    public readonly eventHandler: InAppMessageEventHandler,
    public readonly interactionHandlerFactory: InAppMessageInteractionHandlerFactory,
    public inAppMessageListener: HackleInAppMessageListener | null = null
  ) {}

  setListener(listener: HackleInAppMessageListener | null) {
    this.inAppMessageListener = listener
  }

  async present(context: InAppMessagePresentationContext) {
    if (this.currentMessageView) return
    if (this.opening) return

    this.opening = true

    let messageView: InAppMessageView | null = null
    try {
      messageView = this.messageViewFactory.create(context, this)
      if (messageView === null) return

      this.currentMessageView = messageView
      await messageView.open()
    } catch (e) {
      messageView?.close()
    } finally {
      this.opening = false
    }
  }
}
